import "./upcomingHearings.css";

// Priority badge palette (mockup): High = red, Medium = yellow, Low = green.
const PRIORITY_STYLES = {
  high: { background: "#FEE2E2", color: "#E11D48" },
  medium: { background: "#FEF3C7", color: "#B45309" },
  low: { background: "#DCFCE7", color: "#15803D" },
};

export default function TaskCard({
  title,
  description,
  priority,
}) {
  const badgeStyle =
    PRIORITY_STYLES[(priority || "").toLowerCase()] || {
      background: "#EEF2F7",
      color: "#64748B",
    };

  return (
    <div className="task-card">

      <div className="task-left">

        <div>

          <h4>{title}</h4>

          {description && <p>{description}</p>}

        </div>

      </div>

      <span className="priority-badge" style={badgeStyle}>
        {priority}
      </span>

    </div>
  );
}
